import React from 'react';

import styles from './growth-container.module.less';

interface GrowthContainerProps {
    headerKey: string;
    children: React.ReactNode;
}

export function GrowthContainer(props: GrowthContainerProps) {
    return (
        <div className={styles['growth-container']}>
            <div className={styles['content-container']}>{props.children}</div>
        </div>
    );
}
